import React from 'react';
import {useTranslation} from "react-i18next";
import config from 'root/../config';
import UIComponent from 'components/UiComponent';

const Policy = ({name}) => {

    const {t} = useTranslation();
    const privacyLink = config.apiAppUrl.replace('api/', '') + 'LandingPage/Privacy';

    return(
    	<div className="privacy-policy-link">
			<a href={privacyLink} target="_blank">{t("lbl.PRIVACY_POLICY", "Privacy Policy")}</a>
		</div>
    );
}

export default Policy;




